import { routes } from './routes'
import { AuthenticationConfig } from './authenticationConfigs'
import { RouteRecordRaw } from 'vue-router'

/**
 * Checks if a given path requires authentication based on route configuration
 * @param path The path to check (e.g. "/fleet/123/overview")
 * @returns boolean indicating if the path requires authentication
 */
export function requiresAuthentication(path: string): boolean {
    // Remove query parameters and hash from path
    const cleanPath = path.split('?')[0].split('#')[0]
    
    // Find matching route by recursively checking all routes and their children
    const matchingRoute = findMatchingRoute(cleanPath, routes)
    
    if (matchingRoute?.meta?.authentication) {
      const { authenticated } = matchingRoute.meta.authentication as AuthenticationConfig
      return authenticated === true
    }
    
    return false
  }
  
  /**
   * Recursively searches for a matching route in the route configuration
   * @param path The path to match
   * @param routes Array of routes to search through
   * @returns The matching route or undefined
   */
  function findMatchingRoute(path: string, routes: RouteRecordRaw[]): RouteRecordRaw | undefined {
    for (const route of routes) {
      // Convert route path to regex pattern
      if (typeof route.path === 'string') {
        const pattern = route.path
          // Replace route parameters with regex groups
          .replace(/:[^/]+/g, '[^/]+')
          // Escape forward slashes
          .replace(/\//g, '\\/')
          // Add start/end anchors
        const regex = new RegExp(`^${pattern}$`)
        
        if (regex.test(path)) {
          return route
        }
      }
      
      // Recursively check child routes
      if (route.children) {
        const match = findMatchingRoute(path, route.children)
        if (match) {
          return match
        }
      }
    }
    
    return undefined
  }
  